import { create } from 'zustand';

export const useGlobalSearchStore = create((set) => ({
  showSearch: false,
  searchQueryKey: '',
  setShowSearch: (value) => set({ showSearch: value }),
  setSearchQueryKey: (value) => set({ searchQueryKey: value }),
  setSearch: (show, queryKey = '') =>
    set({ showSearch: show, searchQueryKey: queryKey }),
}));
